import { ReportType } from '../../enums'

const labelsEn = Object.freeze({
  [ReportType.USERS]: 'Members',
  [ReportType.INVENTORY]: 'Inventory',
  [ReportType.MEMBER_MESSAGES]: 'Messages',
  [ReportType.TRANSACTIONS]: 'Transactions',
})

const detailTextUs = Object.freeze({
  [ReportType.USERS]: 'All members',
  [ReportType.INVENTORY]: 'Inventory',
  [ReportType.MEMBER_MESSAGES]: 'Messages to members',
  [ReportType.TRANSACTIONS]: 'Transactions',
})

const reportTypeHelpers = {
  getLabel: (type: ReportType | null | undefined, language = 'en'): string => {
    if (!type) {
      return ''
    }
    if (language === 'en') {
      return labelsEn[type]
    }
    return ''
  },

  getDetailText: (type: ReportType | null | undefined, language = 'en'): string => {
    if (!type) {
      return ''
    }
    if (language === 'en') {
      return detailTextUs[type]
    }
    return ''
  },

  isValid: (type: ReportType | string | null | undefined): boolean =>
    !type || Object.values(ReportType).includes(type as ReportType),
}

export default reportTypeHelpers
